import axios from "axios";
import config from "../config";
import { refreshAccessToken } from "./tokens";
import { toast } from "react-toastify";
import { showLoader, hideLoader } from "./loaderService"; // Create this service or use your existing one
import Logout from "../Pages/Authentication/Logout";

// Import or create a loader management utility

axios.defaults.baseURL = config.API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json";

const token = localStorage.getItem("tokens");
let accessToken = token
  ? JSON.parse(token).AuthenticationResult?.AccessToken
  : null;
let refreshToken = token
  ? JSON.parse(token).AuthenticationResult?.RefreshToken
  : null;

// Request interceptor: Attach token if available and show loader
axios.interceptors.request.use(
  (requestConfig) => {
    // Show loader for this request
    showLoader();
    
    if (accessToken) {
      requestConfig.headers.Authorization = `${accessToken}`;
      requestConfig.headers["Access-Control-Allow-Origin"] = "*";
    }
    return requestConfig;
  },
  (error) => {
    hideLoader();
    return Promise.reject(error);
  }
);

// Response interceptor: Process response and hide loader
axios.interceptors.response.use(
  (response) => {
    hideLoader();
    return response.data ? response.data : response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Handle 403: Refresh Token Flow
    if (error.response?.status === 403 ) {
      localStorage.removeItem("authUser");
      localStorage.removeItem("formResponse");
      localStorage.removeItem("tokens")
      localStorage.removeItem("menu")
      localStorage.removeItem("users")
      window.location.href = "/login";
      return Promise.reject(error);

      // originalRequest._retry = true; // Prevent multiple retries
      // const newAccessToken = await refreshAccessToken();

      // if (newAccessToken) {
      //   axios.defaults.headers.common["Authorization"] = `${newAccessToken}`;
      //   originalRequest.headers.Authorization = `${newAccessToken}`;
      //   hideLoader();

      //   return axios(originalRequest);
      // }
   }

    // Hide loader on error response
    hideLoader();

    // Error Handling
    let message;
    switch (error.response?.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! The data you are looking for could not be found";
        break;
      case 403:
        message = "Access denied. Please login again.";
        break;
      default:
        message = error.response?.data?.message || "An error occurred!";
    }

    // // Show error toast
    // toast.error(message, {
    //   position: "top-right",
    //   autoClose: 3000,
    // });

    return Promise.reject(error);
  }
);

/**
 * Sets the default authorization
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = `${token}`;
};

class APIClient {
  get = (url, params) => axios.get(url, { params });

  create = (url, data) => axios.post(url, data);

  update = (url, data) => axios.put(url, data);

  delete = (url, config) => axios.delete(url, { ...config });
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  return user ? JSON.parse(user) : null;
};

export { APIClient, setAuthorization, getLoggedinUser };